// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1VBfo","validationTips":"StatementDescriptor_validationTips__3SbpA"};